var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class ComponentLoader {
    constructor(telemetryClient, httpClient) {
        // Keeps track of same script being requested multiple times at once
        this.duplicateRequestHandlers = {};
        this.telemetryClient = telemetryClient;
        this.httpClient = httpClient;
        window.__WIDGETS__ = window.__WIDGETS__ || {};
    }
    loadCommon(scriptLocation) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.onload = () => {
                    resolve();
                };
                script.onerror = reject;
                script.src = scriptLocation;
                document.body.appendChild(script);
            });
        });
    }
    load(config) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                if (!this.isValidComponentConfig(config))
                    return;
                const fileName = !config.fileName || config.fileName.length == 0 ? this.getFileName(config.script) : config.fileName;
                if (this.isComponentLoaded(fileName, config.name)) {
                    return resolve(this.getComponentTemplate(fileName, config.name));
                }
                if (this.duplicateRequestHandlers.hasOwnProperty(fileName)) {
                    this.duplicateRequestHandlers[fileName].push({
                        resolve,
                        reject,
                    });
                    return;
                }
                this.duplicateRequestHandlers[fileName] = this.duplicateRequestHandlers[fileName] || [];
                const script = document.createElement('script');
                script.onload = () => {
                    if (this.isComponentLoaded(fileName, config.name)) {
                        const template = this.getComponentTemplate(fileName, config.name);
                        resolve(template);
                        this.duplicateRequestHandlers[fileName].forEach(({ resolve: success }) => success(template));
                    }
                    else {
                        const error = new Error('Script was loaded, but component was not found.');
                        reject(error);
                        this.duplicateRequestHandlers[fileName].forEach(({ reject: fail }) => fail(error));
                    }
                    delete this.duplicateRequestHandlers[fileName];
                };
                script.async = true;
                script.onerror = () => reject(new Error('Failed to load script'));
                script.src = config.script;
                document.body.appendChild(script);
            });
        });
    }
    loadSecured(config, resourceOrScopes) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.httpClient)
                throw new Error('HttpClient is not available for ComponentLoader');
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                if (!this.isValidComponentConfig(config))
                    return;
                const fileName = !config.fileName || config.fileName.length == 0 ? this.getFileName(config.script) : config.fileName;
                if (this.isComponentLoaded(fileName, config.name)) {
                    return resolve(this.getComponentTemplate(fileName, config.name));
                }
                if (this.duplicateRequestHandlers.hasOwnProperty(fileName)) {
                    this.duplicateRequestHandlers[fileName].push({
                        resolve,
                        reject,
                    });
                    return;
                }
                this.duplicateRequestHandlers[fileName] = this.duplicateRequestHandlers[fileName] || [];
                try {
                    const result = yield ((_a = this.httpClient) === null || _a === void 0 ? void 0 : _a.request({
                        url: config.script,
                        responseType: 'text',
                        resource: resourceOrScopes,
                    }));
                    if (result === null || result === void 0 ? void 0 : result.data) {
                        eval(result === null || result === void 0 ? void 0 : result.data);
                        if (this.isComponentLoaded(fileName, config.name)) {
                            const template = this.getComponentTemplate(fileName, config.name);
                            resolve(template);
                            this.duplicateRequestHandlers[fileName].forEach(({ resolve: success }) => success(template));
                        }
                        else {
                            const error = new Error('Script was loaded, but component was not found.');
                            reject(error);
                            this.duplicateRequestHandlers[fileName].forEach(({ reject: fail }) => fail(error));
                        }
                        delete this.duplicateRequestHandlers[fileName];
                    }
                }
                catch (e) {
                    reject(e);
                }
            }));
        });
    }
    getFileName(bundleLocation) {
        const routes = bundleLocation.split('/');
        let fileName = routes.pop();
        if (!fileName)
            return '';
        if (fileName.indexOf('?') > -1)
            fileName = fileName.split('?')[0];
        return fileName.replace('.js', '');
    }
    isComponentLoaded(fileName, componentName) {
        return this.isScriptLoaded(fileName) && !!window.__WIDGETS__[fileName][componentName];
    }
    isScriptLoaded(fileName) {
        return !!window.__WIDGETS__[fileName];
    }
    getComponentTemplate(fileName, componentName) {
        return window.__WIDGETS__[fileName][componentName];
    }
    isValidComponentConfig(componentConfig) {
        if (!componentConfig.script)
            return false;
        if (!componentConfig.name)
            return false;
        return true;
    }
}
//# sourceMappingURL=ComponentLoader.js.map